/* eslint-disable no-else-return */
import Http from './Http';
import { IsMock } from './fetchEnv';
import { ApiConfig, BaseConfig } from './apiConfig/';

const API = (() => {
  const result = {};

  Object.keys(ApiConfig).forEach((key) => {
    // combine config
    const configItem = Object.assign({}, BaseConfig, ApiConfig[key]);

    // pure url
    if (configItem.isUrl) {
      result[key] = `${configItem.apiBaseUrl}${configItem.url}`;
      if (IsMock && configItem.openMock) {
        result[key] = `${configItem.mockBaseUrl}${configItem.url}`;
      }
      return;
    }

    result[key] = (params, formData) => {
      // update headers
      configItem.headers = Object.assign({}, configItem.headers, configItem.getHeaders());

      // update url
      if (configItem.url === null) {
        configItem.url = configItem.getUrl(params);
      }

      // mock
      if (IsMock && configItem.openMock) {
        configItem.headers = {};
        configItem.baseUrl = configItem.mockBaseUrl;
      } else {
        configItem.baseUrl = configItem.apiBaseUrl;
      }
      // fromdata特殊处理
      if (formData) {
        configItem.isFormData = true;
      }

      if (configItem.method === 'post') {
        return Http.post(configItem.url, formData || params, configItem);
      } else {
        return Http.get(configItem.url, formData || params, configItem);
      }
    };
  });

  console.log(result);

  return result;
})();

export default API;



// WEBPACK FOOTER //
// ./src/service/api.js